import { EnvironmentProvider } from "@/common/model";

/** One deploy-time setting asked when deploying an agent into a remote environment. */
export interface DeployField {
	/** Key sent in `deploymentSettings` (matches the backend, e.g. AWS "Region"). */
	key: string;
	label: string;
	required: boolean;
	/** Widget hint. Extend with more types (e.g. "text", "zone") as providers are added. */
	type: "region";
	description?: string;
}

/**
 * Provider-keyed deploy-time settings, mirroring environment-create's `PROVIDER_METADATA_FIELDS`.
 * AWS asks for the target region; other providers plug in their own fields here without a schema
 * change (the values flow through the generic `deploymentSettings` key-value bag).
 */
export const PROVIDER_DEPLOY_FIELDS: Record<string, DeployField[]> = {
	[EnvironmentProvider.AWS]: [
		{
			key: "Region",
			label: "Target Region",
			required: true,
			type: "region",
			description:
				"Region to deploy the agent into. The image is pulled from this region's ECR.",
		},
	],
};
